import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Instagram, X } from "lucide-react";

export const reelId = (url) => {
  const m = (url || "").match(/instagram\.com\/(?:reel|reels|p)\/([A-Za-z0-9_-]+)/);
  return m ? m[1] : null;
};

export const embedUrl = (url) => {
  const m = (url || "").match(/instagram\.com\/(reel|reels|p)\/([A-Za-z0-9_-]+)/);
  if (!m) return null;
  return `https://www.instagram.com/${m[1] === "p" ? "p" : "reel"}/${m[2]}/embed`;
};

export const ReelsModal = ({ reels }) => {
  const [open, setOpen] = useState(false);
  const valid = (reels || [])
    .map((r) => ({ url: typeof r === "string" ? r : r.url, id: reelId(typeof r === "string" ? r : r.url) }))
    .filter((r) => r.id);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="nav-reels-btn"
        className="relative text-zinc-600 hover:text-gold transition-colors duration-300"
        aria-label="Watch brand reels"
      >
        <Instagram size={18} />
      </button>
      <AnimatePresence>
        {open && (
          <>
            <motion.div
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
              className="fixed inset-0 z-[90] bg-black/60 backdrop-blur-sm"
              onClick={() => setOpen(false)}
            />
            <motion.div
              initial={{ opacity: 0, y: 24, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 24, scale: 0.97 }}
              transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="fixed inset-x-4 top-[6%] h-[86vh] md:inset-x-0 md:mx-auto md:w-[860px] z-[95] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col"
              data-testid="reels-modal"
            >
              <div className="flex items-center justify-between px-6 py-4 border-b border-zinc-100">
                <div className="flex items-center gap-2.5">
                  <Instagram size={16} className="text-gold" />
                  <p className="text-sm font-medium text-zinc-900">From our brands on Instagram</p>
                </div>
                <button onClick={() => setOpen(false)} data-testid="reels-close-btn" className="p-2 text-zinc-400 hover:text-zinc-700 transition-colors" aria-label="Close">
                  <X size={18} />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto overscroll-contain p-6" data-lenis-prevent>
                {valid.length === 0 ? (
                  <p className="text-center text-zinc-400 text-sm py-16" data-testid="reels-empty">Reels coming soon — follow our brands on Instagram.</p>
                ) : (
                  <div className={`grid gap-5 ${valid.length === 1 ? "grid-cols-1 max-w-sm mx-auto" : "grid-cols-1 sm:grid-cols-2"}`} data-testid="reels-grid">
                    {valid.map((r) => (
                      <div key={r.id} className="rounded-xl overflow-hidden border border-zinc-200 bg-zinc-50 aspect-[9/14]" data-testid={`reel-${r.id}`}>
                        <iframe
                          src={embedUrl(r.url)}
                          className="w-full h-full"
                          frameBorder="0"
                          scrolling="no"
                          allow="encrypted-media"
                          title="Instagram reel"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};
